import { useCallback, useRef, useState } from 'react';

// React state plus a ref holding the latest value given to its setter.
// Rendering reads the state. A command that runs right after a setter call,
// before React has re-rendered, reads the ref so it sees the new value.
// Every update must go through the returned setter.
export default function useLatestState(initialState) {
    const [state, setState] = useState(initialState);
    const latestRef = useRef(state);
    const setLatestState = useCallback((nextState) => {
        latestRef.current = typeof nextState === 'function'
            ? nextState(latestRef.current)
            : nextState;
        setState(latestRef.current);
    }, []);
    return [state, setLatestState, latestRef];
}
